import gql from 'graphql-tag'

export default gql`
  mutation createService($input: ServiceInput) {
    createService(input: $input) {
      id
    }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/service/create.js